//Exporting constants for other files
export const serverResponseConstants = {
  NETWORK_ERROR: "Network Error",
  SERVER_ISSUE: "unable_to_access_server",
  UNAUTHORIZE_ACCESS: "Unauthorize Access",
  SOMETHING_WENT_WRONG: "Something went wrong",
};

export const responseStatus = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

export const unauthorizedUserAccessKey = "user_not_active";
